export default __webpack_public_path__ + "static/shopify_service_banner-7ccf4374056fc43ab2e1097f8d984101.svg";